import { render, staticRenderFns } from "./BasicSalary.vue?vue&type=template&id=10408e44&"
import script from "./BasicSalary.vue?vue&type=script&lang=js&"
export * from "./BasicSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports